<p>barrel-archive works!</p>
